module.exports = __webpack_public_path__ + "static/media/goblin_big_momma.1947fc42.svg";